import {
  toRefs,
  ref,
  computed,
  watch,
  onMounted,
  inject,
  onUnmounted,
  nextTick,
  provide
} from "vue";

import useChatStore  from "@/store/chat";
import useUsuarioStore from "@/store/usuario";
import useMensajeStore from '@/store/mensaje';



export default function useChatbot() {

  const formValidate = ref(null);
  const chat_store = useChatStore();
  const usuario_store = useUsuarioStore();
  const mensaje_store = useMensajeStore();

  const { chat } = toRefs(chat_store);
  const { usuario } = storeToRefs(usuario_store);
  const {mensaje:formulario,mensajes} = storeToRefs(mensaje_store);
  const usuario_id = computed(() => usuario.value.id ?? null);

  const showChatbot = ref(false);
  const aperturado = ref(false);

  const chat_id = computed(() => chat.value.id);

  // Scroll to Bottom ChatLog
  const refChatLogPS = ref(null);

  // methods

  const enviar = (values, next = () => ({})) => {

      formulario.value = {
        ...values,
        chat_id: chat_id.value || chat.value.id || localStorage.getItem('chat_id'),
      };

      mensaje_store.enviarMensaje(formulario.value)
      .then(({result,mensaje_asistente}) => {
          if(result){
            mensaje_store.clear();
            next();
            scrollToBottomInChatLog();

            escucharRespuesta(mensaje_asistente);
          }else{
            toast.info('No se pudo enviar el mensaje');
          }
      }).catch(e => {
        toast.error('Error al enviar el mensaje');
        console.log(e);
      });

  };

  const escucharRespuesta = (msj ) => {
    
    Echo.private(`mensaje.${msj.id}`)
    .listen('.nuevo.chunk',({mensaje:ms}) => {
      let ch_id = chat_id.value || localStorage.getItem("chat_id");
      if(ms && ms.chat_id == ch_id){
          mensaje_store.actualizarMensaje(ms);
          setTimeout(() => {
            scrollToBottomInChatLog();
          }, 300);
      }

    });

  }


  const scrollToBottomInChatLog = () => {

    if(refChatLogPS.value == null) return;


    const scrollEl = refChatLogPS.value.$el || refChatLogPS.value;
    scrollEl.scrollTo({
      top: scrollEl.scrollHeight,
      behavior: "smooth",
    });

    // scrollEl.scrollTop = scrollEl.scrollHeight;
  };

  watch(refChatLogPS, () => {
    scrollToBottomInChatLog();
  });

  const cerrar = () => {
    mensaje_store.clear();
    showChatbot.value = false;
  };

  const aperturarChat = (next = () => ({})) => {

    let iform = document.querySelector(".input-form");

    if (iform) {
      iform.focus();
    }


    if(usuario_id.value){
       chat_store
         .aperturarChat({
           usuario_id: usuario_id.value,
         })
         .then(({ result }) => {
           if (result) {
             aperturado.value = true;
             nextTick(() => {
               next();
               scrollToBottomInChatLog();
             });
           }
         });
    }

  };

  const aperturarEcho = () => {
    let ch_id = chat_id.value || localStorage.getItem("chat_id");

    if(ch_id){
       Echo.private(`chat.${ch_id}`)
         .listen(".mensaje.respondido", ({mensaje:msj}) => {
            if (msj.chat_id == ch_id) {
              mensaje_store.actualizarMensaje(msj);
              
              setTimeout(() => {
                scrollToBottomInChatLog();
              }, 300);

            }
         });
    }
  };

  const cargarMensajes = (ch_id) => {
    mensaje_store.cargarMensajes(ch_id)
    .then(() => scrollToBottomInChatLog());
  }


  const verificarExistenciaChatbot = (ch_id) => {
    if (ch_id) {
      chat_store.fetchIfActivo(ch_id)
      .then(({result}) => {
        if(result){
          aperturado.value = true;
          cargarMensajes(ch_id);
        }else{
          localStorage.removeItem("chat_id");
          toast.info("El chat anterior ha finalizado");
        }
      });

    }else{
      chat_store.aperturarChat({
        usuario_id:usuario_id.value
      })
      .then(({result}) => {
        if(result){

          aperturado.value = true;
          cargarMensajes(chat.value.id);

          nextTick(() => {
            scrollToBottomInChatLog();
          });
        }
      })
    }

  };

  const leaveChannel = () => {
    if (chat_id.value) {
      Echo.leaveChannel(`chat.${chat_id.value}`);
    }
  };

  onMounted(() => {
    // verificarExistenciaChatbot(localStorage.getItem("chat_id"));
    aperturarEcho();
  });


  watch(mensajes, () => {
    if (aperturado.value) {
      nextTick(() => {
        scrollToBottomInChatLog();
      });
    }
  });

  onUnmounted(() => {
    leaveChannel();
  });

  const verificarUsuario = () => {
    if (usuario_id.value != chat.value.usuario_id) {
      aperturado.value = false;
      chat_store.clear();
    }
  };

  watch([usuario_id, () => chat.value.usuario_id], () => {
    if (usuario_id.value && chat.value.usuario_id) {
      verificarUsuario();
    }
  });

  watch(() => chat_id.value, () => {
    leaveChannel();
    aperturarEcho();
  });

  const cerrarChat = () => {
    chat_store.cerrarChat(chat_id.value)
    .then(({result}) => {
      
      if(result){
        leaveChannel();
        localStorage.removeItem("chat_id");

        aperturarChat(() => {
            aperturarEcho();
            toast.info("Se ha creado un nuevo chat, el chat anterior ha finalizado");
            mensaje_store.clearMensajes();
        });

      }else{
        toast.error('No se pudo cerrar el chat');
      }

    })
    .catch(e => {
      
      console.log(e);

    });

  };

  const esperandoRespuesta = computed(() => {

      if (mensajes.value.length > 0 && mensajes.value[mensajes.value.length - 1].respondido === false) {
        return true;
      }
      return false;

  });


  const chatAbierto  =() => {
      verificarExistenciaChatbot(localStorage.getItem("chat_id"));
      aperturarEcho();
  }





  return {
    formValidate,
    mensajes,
    formulario,
    showChatbot,
    aperturado,
    chat,
    refChatLogPS,
    esperandoRespuesta,
    // methods
    enviar,
    cerrar,
    aperturarChat,
    scrollToBottomInChatLog,
    cerrarChat,
    verificarExistenciaChatbot,
    chatAbierto,
  };

}
